import type { OperationStatus } from './apis/apiResponse.model';

export enum FeatureFlagsRequestType {
  GET_FEATURE_FLAGS = 'Get Feature Flags',
}

export type FeatureFlagValueType =
  | string
  | boolean
  | number
  | { [k: string]: FeatureFlagValueType };

export type FeatureFlag = {
  name: string;
  value: FeatureFlagValueType;
};

export type FeatureFlagsState = {
  operations: {
    [key in FeatureFlagsRequestType]?: OperationStatus;
  };
};

export const CHARGING_SCHEDULE_FLAG_NAME = '34205-Charging-Schedule-Config';
export const PERIPHERALS_FLAG_NAME = 'F52881-PERIPHERALS';
export const DRIVERS_FLAG_NAME = 'SDPCDXP-288-DRIVERS-MANAGEMENT';
export const CREATE_NEW_FLEET_FLAG_NAME = 'F54585-CREATE-NEW-FLEET';
export const CHANGE_DEFAULT_FLEET_FLAG_NAME =
  'SDPCPLT-5656-Change-Default-Fleet';
// Charge Level Widget Added to Dashboard View 9/19/2024
export const DASHBOARD_CHARGE_LEVEL = 'F52359-Charge-Level-Widget';
// Global Search flag added 7 Oct 2024 automatically expires 31 Mar 2025
export const GLOBAL_SEARCH_FLAG_NAME = 'F51951_Global_Search';
export const REMOTE_COMMANDS_FLAG_NAME = 'F53692-Remote-Commands';
export const CAPS_FLAG_NAME = 'F52239-CAP-AGREEMENTS-PAGE';
export const RECALLS_FLAG_NAME = '50343-Recall';
export const HOME_CHARGE_SWITCHER_FLAG =
  'SDPCPLT-2119-Home-Charge-Reimbursement';
export const PUB_SUB_FLAG = 'F53760-ENABLE-PUBSUB-ALERTS';
export const EXPIRED_STALE_DATA_FLAG = 'F50012-Enable-Stale-Data';
// Org Details flag for v0.5 added 7 Feb 2025
export const ORG_DETAILS_FLAG = 'F52152_Org_Details';
export const FAQS_PAGE_FLAG = 'SDPCPLT-63-FAQS-PAGE';
export const LEGAL_PAGE_FLAG = 'SDPCPLT-79-LEGAL-PAGE';
export const REMOTE_ENABLE_DISABLE_FLAG = 'SDPCPLT-1058-REMOTE-ENABLE-DISABLE';
export const FLEET_MAP_FLAG = 'SDPCPLT-735-VEHICLE-MAP';
export const GEOFENCES_FLAG = 'SDPCPLT-1484-Geofences';
export const GEOFENCE_SPEEDING_FLAG = 'SDPCINS-2404-Geofence-Speeding';
export const CHARGE_STATIONS_FLAG =
  'SDPCPLT-665-Real-Time-Charging-Station-Locator';
export const VEHICLE_DETAILS_OVERVIEW_FLAG =
  'SDPCPLT-1238-VEHICLE-DETAILS-OVERVIEW';
export const VEHICLE_DETAILS_LOCATION_FLAG =
  'SDPCPLT-1238-VEHICLE-DETAILS-LOCATION';
export const VEHICLE_DETAILS_TRIPS_FLAG = 'SDPCPLT-1238-VEHICLE-DETAILS-TRIPS';
/** When `true`, hides the Location tab on the vehicle details page. */
export const HIDE_VEHICLE_DETAILS_LOCATION_FLAG = 'SDPCPLT-9670-hide-locations';
export const USER_ACTIONS_MENU_FLAG = 'SDPCPLT-1124-USER-ACTIONS-MENU';
export const EDIT_USER_ROLE_FLEET_FLAG = 'SDPCPLT-1124-USER-EDIT-ROLE-FLEET';
export const CATALOG_FLAG = 'SDPCPLT-915-BPSE'; // catalog feature flag
export const DRIVE_BLOCK_CONFIRMATION_MODAL =
  'SDPCPLT-1625-DRIVE-BLOCK-WARNING';
export const PENDING_CONNECTION_TABLE_FEATURE_FLAG =
  'SDPCPLT-1942-pending-connection-table';
export const REPORTS_FLAG = 'SDPCINS-618-CSP-Reporting';
export const REPORTS_USER_SETTINGS_FLAG =
  'SDPCINS-618-CSP-Reporting-user-settings';
export const SCHEDULED_REPORTS_FLAG = 'SDPCINS-2330-Scheduled-Reports';
export const SAFETY_PAGE_FLAG = 'SDPCDXP-555-SAFETY-PAGE';
export const UNASSIGNED_VEHICLES_SCORE_FLAG =
  'SDPCDXP-1252-unassigned-vehicles-score';
export const CUSTOM_VIDEO_REQUEST_FLAG = 'SDPCDXP-1287-Custom-Video';
export const MIGRATE_ADD_VEHICLES_BUTTON_FLAG =
  'SDPCPLT-2819-Migrate-Add-Vehicles-Button';
export const VEHICLE_LOCATION_MASK_UNMASK_FLAG =
  'SDPCPLT-3317-Vehicle-Location-Mask-Notification-Settings';
export const INSIGHTS_IN_CSP_FLAG = 'SDPCINS-1014-Insights-In-CSP';
export const DRIVE_BLOCK_RULE_SUBSCRIPTION_FLAG =
  'SDPCPLT-3316-Drive-Block-Rule-Subscription';
export const NOT_EQUIPPED_FLAG = 'SDPCPLT-4046-NOT-EQUIPPED';
export const TABLE_TOOLBAR_OVERHAUL_FLAG = 'SDPCFA-192-Table-Toolbar-Overhaul';
export const LOCATION_MASKING_VEHICLE_DETAILS_FLAG =
  'SDPCPLT-4782-LM-vehicle-details';
export const VEHICLE_DETAILS_ROUTING_UPDATES_FLAG =
  'SDPCPLT-4675-Vehicle-Details-Routing-Updates';
export const MARCH_VEHICLE_MANAGEMENT_FLAG =
  'SDPCPLT-4685-march-vehicle-management';
export const LOCATION_MASKING_FLEET_MAP_FLAG = 'SDPCPLT-4818-LM-fleetmap';
export const VEHICLE_INACTIVITY_IDLING_FLAG =
  'SDPCPLT-4964-VEHICLE-INACTIVITY-IDLING';
export const VEHICLE_BOARDING_HISTORY_FLAG = 'Vehicle-Boarding-History';
export const PERIPHERAL_ADAPTERS_FLAG_NAME = 'SDPCPLT-2460-Peripheral-Adapters';
export const VEHICLE_LIST_LOCATION_MASKING_FLAG =
  'SDPCPLT-4928-LM-vehicle-overview';
export const VEHICLE_LIST_EVS_CONNECTED_ONLY_FLAG =
  'SDPCPLT-4746-Vehicle-List-EVs-Connected-Only';
export const CUSTOMER_SUPPORT_V2_FLAG = 'SDPCPLT-3692-Customer-Support';
export const TRIP_HISTORY_LOCATION_MASKING_FLAG = 'SDPCPLT-5181-LM-trips';
export const VEHICLE_BOARDING_ENHANCEMENTS_FLAG =
  'SDPCPLT-5199-Vehicle-Boarding-Enhancement';
export const FEEDBACK_LOOP_FLAG = 'SDPCPLT-5759-Feedback-Loop';
export const SHOP_ADD_ONS_FLAG = 'SDPCPLT-3435-Shop-Add-Ons';
export const FEEDBACK_ATTACHMENTS_FLAG = 'SDPCPLT-6263-feedback-attachments';
export const PERIPHERAL_PURCHASE_FLAG = 'SDPCPLT-6019-Peripheral-Purchase';
export const DISCOUNTS_POST_SALES_FLAG = 'SDPCPLT-5833-Discounts-Post-Sales';
export const GM_FLEET_LOGO_FLAG = 'SDPCDXP-1626-GM-FLEET-LOGO';
export const VEHICLE_ORDER_LIST_IMPORTED_ORDERS_UI_FLAG =
  'SDPCPLT-5985-Vehicle-Orders-Table-Imported';
export const AUTO_VEHICLE_ONBOARDING_FLAG =
  'SDPCPLT-6727-Auto-Vehicle-Onboarding';
export const GM_FLEET_REBRAND_FLAG = 'SDPCPLT-6545-gm-fleet-rebrand';
export const INVOICE_ME_FLAG = 'SDPCPLT-6215-Invoice-Me';
export const RPO_PREPAID_FLAG = 'SDPCPLT-6474-RPO-Prepaid';
export const NEW_CONNECTIVITY_STATUS_FLAG =
  'SDPCPLT-6670-new-connectivity-status';
export const ONSTAR_FLEET_INTELLIGENCE_REBRAND_FLAG =
  'SDPCPLT-7215-onstar-fleet-intelligence-rebrand';
export const LANGUAGE_SWITCHER_FLAG = 'SDPCINS-1925-CSP-LANGUAGE-SWITCHER';
export const MIGRATION_WELCOME_EXPERIENCE_FLAG =
  'SDPCPLT-6249-Migration-Welcome-Experience';
export const BATTERY_12V_PROGNOSTICS_FLAG =
  'SDPCINS-1835-12V-Battery-Prognostics';
export const LOGIN_UPDATE_FLAG = 'SDPCPLT-8172-LOGIN-UPDATE';
export const FUEL_CARD_AND_EXPENSES_FLAG =
  'SDPCPLT-8058-Fuel-Card-And-Expenses';
export const NEW_FAN_SIGNUP_URL_FLAG = 'SDPCPLT-8489-FAN-APPLICATION-LINKOUT';
export const INVOICE_ME_TOGGLE_FLAG = 'SDPCPLT-8647-Enable-Invoice-Me-Toggle';
export const LOCALIZATION_CORE_FLAG = 'SDPCPLT-8060-Localization-core';
export const LOCALIZATION_FEATURE_FLAG =
  'SDPCPLT-8060-Localization-on-features';
export const FLEETIO_ACCOUNT_LINKING_FLAG =
  'SDPCPLT-8905-Fleetio-Account-Linking';
export const ADVISOR_TOOL_GMF_FLAG = 'SDPCPLT-8508-GMF-Linking-Advisor-Tool';
/**
 * EMER events and notifications: EMER alerts in the notification feed and
 * header badge, and the full-page notification settings with their Emergency
 * notifications for Protect accounts. While off, EMER alerts stay hidden and
 * notification settings keep the list pages and edit dialog.
 */
export const EMER_FLAG = 'SDPCDXP-1821-EMER';
export const BPS_MEXICO_CATALOG_SUPPORT_FLAG =
  'SDPCPLT-8824-BPS-Mexico-Catalog-Support';
export const CI_DEMO_FLAG = 'SDPCDOS-3132-CI-Demo';
